import { Link } from "react-router-dom";
import { ArrowUpRight, Key, Car, Footprints, ShieldCheck, Watch, Type, Stamp, Scissors, Zap, Briefcase, PartyPopper, Package } from "lucide-react";
import BeforeAfter from "@/components/BeforeAfter";

const SHOE_BEFORE = "https://images.unsplash.com/photo-1520639888713-7851133b1ed0?auto=format&fit=crop&w=1200&q=70";
const SHOE_AFTER  = "https://images.unsplash.com/photo-1449505278894-297fdb3edbc1?auto=format&fit=crop&w=1200&q=70";

const services = [
    {
        icon: Key,
        title: "Schlüsseldienst",
        images: [
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/wkntmls3_WhatsApp%20Image%202026-04-30%20at%2021.40.30%20%281%29.jpeg",
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/8ffy8rf1_WhatsApp%20Image%202026-04-30%20at%2021.40.32%20%281%29.jpeg",
        ],
        text: "Sofortige Anfertigung aller Schlüsselarten – von Haus-, Briefkasten- und Buntbartschlüsseln bis hin zu Sicherheits- und Autoschlüsseln. Präzise, schnell und zuverlässig mit modernster Technik.",
    },
    {
        icon: Car,
        title: "Programmierung von Autoschlüsseln",
        images: [
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/m1epyuup_WhatsApp%20Image%202026-04-30%20at%2021.40.30.jpeg",
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/ak04khtj_WhatsApp%20Image%202026-04-30%20at%2021.40.31.jpeg",
        ],
        text: "Fachgerechte Programmierung und Codierung von Autoschlüsseln, Transponderschlüsseln und Funkfernbedienungen aller Marken – auch bei Ersatz- oder Verlustschlüsseln. Zusätzlich bieten wir den Austausch defekter Autoschlüssel-Gehäuse direkt vor Ort und sofort an.",
    },
    {
        icon: Footprints,
        title: "Schuhreparatur",
        image: "https://images.pexels.com/photos/28387105/pexels-photo-28387105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
        text: "Moderne Schuhreparatur vom Fachbetrieb – präzise, hochwertig und oft sofort vor Ort. Wir reparieren Absätze, Laufsohlen, Innen- und Außensohlen sowie abgelaufene Fersen und beschädigtes Innenfutter. Zusätzlich bieten wir orthopädische Anpassungen, Erhöhungen, Klebe- und Näharbeiten sowie fachgerechte Reparaturen aller Art rund um den Schuh an. Handwerkliche Qualität für mehr Komfort, Haltbarkeit und neuen Laufkomfort.",
        beforeAfter: true,
    },
    {
        icon: Watch,
        title: "Uhrenservice",
        images: [
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/84sqj7ks_Uhrenservice.jpeg",
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/ksr85got_Uhrenservice2.jpeg",
        ],
        text: "Professioneller Uhrenservice direkt vor Ort – von Batteriewechseln über Armbandwechsel bis hin zu Reparaturen mit Kleinteilen. Wir kürzen oder verlängern Armbänder, tauschen Federstege, Verschlüsse und Zubehör fachgerecht aus und übernehmen nahezu alle kleinen Arbeiten rund um Ihre Uhr. Schnell, präzise und meist sofort erledigt.",
    },
    {
        icon: Type,
        title: "Gravur",
        image: "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/mjw3w4jf_WhatsApp%20Image%202026-04-30%20at%2021.40.31%20%284%29.jpeg",
        text: "Präzise Gravuren direkt vor Ort – schnell, sauber und dauerhaft. Wir gravieren Briefkasten-, Klingel- und Türschilder, Vorhängeschlösser, Schlüsselanhänger, Geschenke und persönliche Erinnerungsstücke. Ob individuell, geschäftlich oder für Paare – nahezu jede Gravur wird professionell und meist sofort umgesetzt.",
    },
    {
        icon: Stamp,
        title: "Stempel",
        image: "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/9469awz0_stempel.jpeg",
        text: "Individuelle Stempellösungen für Alltag, Büro und Gewerbe – modern, sauber gefertigt und schnell einsatzbereit. Ob komplette Stempel, Ersatzplatten oder Stempelkissen für verschiedenste Modelle: Wir bieten hochwertige Lösungen für Privat- und Geschäftskunden. Von klassischen Namens- und Adressstempeln bis hin zu individuellen Firmenstempeln.",
    },
    {
        icon: Scissors,
        title: "Näharbeiten",
        image: "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/s5vgu4i4_Na%CC%88harbeiten.jpeg",
        text: "Professionelle Näh- und Reparaturarbeiten – besonders für Lederartikel und robuste Materialien. Ob Taschen, Schuhe, Gürtel, Geldbörsen oder andere Lederwaren: Wir übernehmen Reparaturen, Nähte und Ausbesserungen fachgerecht, sauber und langlebig. Handwerkliche Qualität, schnelle Umsetzung und viele Arbeiten direkt vor Ort.",
    },
    {
        icon: Zap,
        title: "Schleifarbeiten",
        image: "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/bq5bjnzf_Schleifarbeiten.jpeg",
        text: "Professionelles Schleifen von Messern, Scheren und Werkzeugen für optimale Schärfe und beste Ergebnisse.",
    },
    {
        icon: Briefcase,
        title: "Lederartikel",
        image: "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/wae9w2j4_Lederartikel.jpeg",
        text: "Fachgerechte Reparatur und Pflege von Taschen, Gürteln und Lederwaren – für ein gepflegtes und langlebiges Ergebnis.",
    },
    {
        icon: PartyPopper,
        title: "Helium-Ballons",
        images: [
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/0bw2tfz9_Helium.jpeg",
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/qi4eto45_Zubeho%CC%88r.jpeg",
        ],
        text: "Hochwertig befüllte Helium-Ballons für Feiern, Events und besondere Anlässe – schnell und zuverlässig bereitgestellt.",
    },
    {
        icon: Package,
        title: "Zubehör",
        images: [
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/hgasf0v0_Zubeho%CC%88r3.jpeg",
            "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/m0dwrqym_Zuberho%CC%88r%202.jpeg",
        ],
        text: "Große Auswahl an Zubehör rund um Schlüssel, Schuhe und Lederpflege. Bei uns finden Sie Schlüsselringe, Schlüsselköpfe, Schlüsselanhänger, Karabiner und vieles mehr rund um den Schlüsselbereich. Zusätzlich bieten wir Schnürsenkel, Schuhcremes, Lederpflege, Bürsten, Schuhlöffel, Einlegesohlen und viele weitere praktische Artikel für Schuhe und Lederwaren. Hochwertig, nützlich und direkt vor Ort erhältlich.",
    },
];

export default function Leistungen() {
    return (
        <div data-testid="page-leistungen">
            {/* Header */}
            <section className="pt-16 md:pt-24 pb-16 border-b border-line">
                <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-7">
                        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] font-medium text-ink">
                            Handwerk, das <span className="italic text-brand">hält</span>.<br/>
                            Service, der <span className="italic text-brand">schnell</span> ist.
                        </h1>
                    </div>
                    <div className="lg:col-span-5">
                        <p className="font-body text-base md:text-lg font-light text-inkSoft leading-relaxed">
                            Von der Schuhreparatur bis zum programmierten Autoschlüssel und
                            vielem mehr.
                        </p>
                        <p className="mt-4 font-body text-base md:text-lg font-semibold text-brand tracking-wide">
                            Schnell · Zuverlässig · Direkt vor Ort
                        </p>
                    </div>
                </div>
            </section>

            {/* Services — PowerPoint row layout */}
            <section className="divide-y divide-line">
                {services.map((s, i) => {
                    const reverse = i % 2 === 1;
                    return (
                        <article
                            key={s.title}
                            data-testid={`service-row-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="py-20 md:py-28"
                        >
                            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                                {/* Image */}
                                <div className={`lg:col-span-6 ${reverse ? "lg:order-2" : ""}`}>
                                    {s.beforeAfter ? (
                                        <BeforeAfter before={SHOE_BEFORE} after={SHOE_AFTER} />
                                    ) : s.images ? (
                                        <div className="grid grid-cols-2 gap-2 aspect-[4/3]">
                                            {s.images.map((img, k) => (
                                                <div key={k} className="overflow-hidden rounded-sm">
                                                    <img src={img} alt={s.title} className="w-full h-full object-cover" />
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="aspect-[4/3] overflow-hidden rounded-sm bg-paper">
                                            <img
                                                src={s.image}
                                                alt={s.title}
                                                className={`w-full h-full ${s.objectFit === "contain" ? "object-contain" : "object-cover"}`}
                                                style={{ objectPosition: s.objectPosition || "center" }}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* Text */}
                                <div className={`lg:col-span-6 ${reverse ? "lg:order-1" : ""}`}>
                                    <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-[1] text-ink font-bold">
                                        {s.title}
                                    </h2>
                                    <p className="mt-6 font-body text-base font-light text-inkSoft leading-relaxed max-w-xl">
                                        {s.text}
                                    </p>
                                    {s.beforeAfter && (
                                        <p className="mt-6 font-body text-xs tracking-[0.2em] uppercase text-brand">
                                            ← Schieber ziehen für Vorher / Nachher
                                        </p>
                                    )}
                                </div>
                            </div>
                        </article>
                    );
                })}
            </section>

            {/* CTA band */}
            <section className="py-20">
                <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
                    <div className="bg-ink text-paper p-10 md:p-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                        <h2 className="font-display text-3xl md:text-4xl tracking-tight leading-tight max-w-xl">
                            Wir freuen uns auf Ihren Besuch.
                        </h2>
                        <Link
                            to="/kontakt"
                            data-testid="leistungen-cta-contact"
                            className="inline-flex items-center gap-3 bg-brand text-paper px-8 py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-brandDark transition-colors shrink-0"
                        >
                            Kontakt <ArrowUpRight size={16} />
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
